import React from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import { Clock, HelpCircle, Percent, RefreshCw, Target } from 'react-feather'
import { Typography  } from 'antd'

import { CourseAvailableForPurchasePreview } from './types'
import { FlexRow, FlexColumn } from '../FlexboxReusables/FlexItems'
import ExamInstructionsBlock from '../CourseForParticipants/ExamInstructions/ExamInstructionsBlock'

type ExamOverviewProps = {
  course: CourseAvailableForPurchasePreview
}

const ExamOverview: React.FC<ExamOverviewProps> = (props) => {
  const { course } = props
  const intl = useIntl()

  return (
    <FlexRow>
      <FlexColumn>
        <Typography.Title level={2}>
          <FormattedMessage id='generic.exam' />
        </Typography.Title>
        <FlexColumn>
          <ExamInstructionsBlock
            Icon={Percent}
            heading={intl.formatMessage({ id: 'exam.minPercentageToPass' })}
            text={`${course.minPercentageToPass}%`}
            centered
          />
          <ExamInstructionsBlock 
            Icon={Target}
            heading={intl.formatMessage({ id: 'exam.totalPointsToAchieve' })}
            text={course.totalPoints || 0}
            centered
          />
          <ExamInstructionsBlock
            Icon={Clock}
            heading={intl.formatMessage({ id: 'exam.examDurationLong' })}
            text={course.examDurationInMinutes || 0}
            centered
          />
          <ExamInstructionsBlock 
            Icon={HelpCircle}
            heading={intl.formatMessage({ id: 'exam.numberOfQuestions' })}
            text={course.questions.length}
            centered
          />
          <ExamInstructionsBlock 
            Icon={RefreshCw}
            heading={intl.formatMessage({ id: 'exam.maxTries' })}
            text={course.maxTries || 0}
            centered
          />
        </FlexColumn>
      </FlexColumn>
    </FlexRow>
  )
}

export default ExamOverview